<template>
    <div>
        <div class="pagetitle">
            <h1>Data Master Pertanyaan</h1>
            <nav>
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">Home</li>
                    <li class="breadcrumb-item">Forms</li>
                    <li class="breadcrumb-item active">Data Master Pertanyaan</li>
                </ol>
            </nav>
        </div>
        <div class="col text-left">
            <a href="#" class="btn btn-sm btn-primary shadow-sm" data-toggle="modal" data-target="#tambahQuestion">
                <i class="bi bi-plus fa-sm text-white-50"></i> Tambah Pertanyaan
            </a>
        </div>
        <br>
        <div class="row mb-3">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <h5 class="card-title">Pertanyaan</h5>
                        <div>
                            <label for="searchQuery" class="form-label">Search:</label>
                            <input type="text" class="form-control" id="searchQuery" v-model="searchQuery" @change="getQuestion" placeholder="Search...">
                            <div class="form-group mb-3">
                                <label for="pageSize" class="form-label">Items per page:</label>
                                <select name="pageSize" id="pageSize" class="form-select" v-model="pageSize" @change="getQuestion">
                                    <option v-for="size in sizes" :key="size" :value="size">
                                        {{ size }}
                                    </option>
                                </select>
                            </div>
                            <table class="table table-striped table-hover">
                                <thead class="thead-dark">
                                    <tr>
                                        <th scope="col">No</th>
                                        <th scope="col">Question</th>
                                        <th scope="col">Status</th>
                                        <th scope="col" style="text-align: center;">Opsi</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(question, index) in filteredQuestion" :key="index">
                                        <td>{{ index + 1 + (currentPage-1) * pageSize }}</td>
                                        <td>{{ question.question }}</td>
                                        <td>
                                            <span v-if="question.status == '1'" class="badge bg-success">Active</span>
                                            <span v-else class="badge bg-danger">Inactive</span>
                                        </td>
                                        <td style="text-align:center">
                                            <a href="#" class="btn btn-sm btn-outline-primary shadow-sm" style="margin-right: 5px" @click="showModal('detail', question.id)">
                                                <i class="bi bi-eye fa-sm text-dark"></i>
                                            </a>
                                            <a href="#" class="btn btn-sm btn-outline-danger shadow-sm" style="margin-right: 5px" @click="deleteQuestion(question.id)">
                                                <i class="bi bi-trash fa-sm text-dark"></i>
                                            </a>
                                            <a href="#" class="btn btn-sm btn-outline-warning shadow-sm" style="margin-right: 5px" @click="showModal('edit', question.id)">
                                                <i class="bi bi-pencil-square fa-sm text-dark"></i>
                                            </a>
                                            <a href="#" class="btn btn-sm btn-secondary shadow-sm" style="margin-right: 5px" @click="showModal('answer_detail', question.id)">
                                                <i class="bi bi-link fa-sm text-light"></i> Tambahkan Detail
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <nav aria-label="Page navigation">
                                <ul class="pagination justify-content-center" @change="getQuestion">
                                    <li class="page-item" :class="{ disabled: currentPage === 1}">
                                        <button class="page-link" @click ="changePage(currentPage - 1)" :disabled="currentPage === 1">Previous</button>
                                    </li>
                                    <li v-if="showStartEllipsis" class="page-item disabled">
                                        <span class="page-link">...</span>
                                    </li>
                                    <li
                                        class="page-item"
                                        v-for="page in displayedPages"
                                        :key="page"
                                        :class="{ active: currentPage === page }"
                                    >
                                        <button class="page-link" @click="changePage(page)">{{ page }}</button>
                                    </li>
                                    <li v-if="showEndEllipsis" class="page-item disabled">
                                        <span class="page-link">...</span>
                                    </li>
                                    <li class="page-item" :class="{ disabled: currentPage === pages }">
                                        <button class="page-link" @click="changePage(currentPage + 1)" :disabled="currentPage === pages">Next</button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal Tambah -->
        <div class="modal fade" id="tambahQuestion" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="tambahSuratModalLabel">Question Forms</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form class="row g-3" @submit.prevent="addQuestion">
                            <div class="col-md-12">
                                <div class="form-floating">
                                    <input type="text" class="form-control" id="ID" placeholder="ID" v-model="question.created_by" readonly>
                                    <label for="ID">ID</label>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-floating">
                                    <input type="text" class="form-control" id="nama" placeholder="nama" v-model="question.created_by_name" readonly>
                                    <label for="nama">Nama</label>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-floating">
                                    <input type="text" class="form-control" id="floatingName" placeholder="Title" v-model="question.question">
                                    <label for="floatingName">Pertanyaan</label>
                                </div>
                            </div>
                            <div class="col-md-12 mb-3">
                                <div class="form-floating">
                                    <select class="form-select" name="language" id="is_active" v-model="question.language">
                                        <option value="id">🇮🇩 Indonesia</option>
                                        <option value="en">🇬🇧 English</option>
                                    </select>
                                    <label for="language">Bahasa</label>
                                </div>
                            </div>
                            <div class="col-md-12 mb-3">
                                <div class="form-floating">
                                    <select class="form-select" name="is_active" id="is_active" v-model="question.status">
                                        <option value="1">Active</option>
                                        <option value="0">Inactive</option>
                                    </select>
                                    <label for="is_active">Status</label>
                                </div>
                            </div>
                            <div class="text-center">
                                <button type="submit" class="btn btn-primary">Submit</button> ||
                                <button type="reset" class="btn btn-secondary" @click="resetForm">Reset</button>
                            </div>
                        </form><!-- End floating Labels Form -->
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal Detail  -->
        <div ref="detailQuestionModal" class="modal fade" id="detailQuestion" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="detailQuestionModal">Detail Question</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="title">Question</label>
                                        <input type="text" class="form-control" id="title" placeholder="Title" v-model="question.question" readonly>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="pembuat_nama">Nama Pembuat</label>
                                        <input type="text" class="form-control" id="pembuat_nama" placeholder="Nama Pembuat" v-model="question.created_by_name" readonly>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="language">Bahasa</label>
                                        <input type="text" class="form-control" id="language" placeholder="Bahasa" :value="question.language === 'id' ? '🇮🇩 Indonesia' : '🇬🇧 English'" readonly>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="is_active">Status</label>
                                        <select class="form-control" name="is_active" id="is_active" v-model="question.status" disabled>
                                            <option value="1">Active</option>
                                            <option value="0">Inactive</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="text-center">
                            <button class="btn btn-secondary" @click="closeModal"> Close </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal Edit -->
        <div class="modal fade" id="editQuestion" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="editQuestionLabel">Edit Question</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form class="row g-3" @submit.prevent="updateQuestion">
                            <div class="col-md-12">
                                <div class="form-floating">
                                    <input type="text" class="form-control" id="floatingName" placeholder="ID" v-model="question.id" readonly/>
                                    <label for="floatingName">ID Question</label>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-floating">
                                    <input type="text" class="form-control" placeholder="Question" id="floatingName" v-model="question.question">
                                    <label for="floatingName">Question</label>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-floating">
                                        <input type="text" class="form-control" id="updated_by" placeholder="ID" v-model="selectedQuestion.updated_by" readonly/>
                                        <label for="updated_by">ID</label>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-floating">
                                <input type="text" class="form-control" id="updated_by_name" placeholder="Nama PEmbuat" v-model="selectedQuestion.updated_by_name" readonly/>
                                <label for="updated_by_name">Nama</label>
                                </div>
                            </div>
                            <div class="col-md-12 mb-3">
                                <div class="form-floating">
                                    <select class="form-select" name="language" id="is_active" v-model="question.language">
                                        <option value="id">🇮🇩 Indonesia</option>
                                        <option value="en">🇬🇧 English</option>
                                    </select>
                                    <label for="language">Bahasa</label>
                                </div>
                            </div>
                            <div class="col-md-12 mb-3">
                                <div class="form-floating">
                                <select class="form-select" name="is_active" id="is_active" v-model="question.status">
                                    <option value="1">Active</option>
                                    <option value="0">Inactive</option>
                                </select>
                                <label for="is_active">Status</label>
                                </div>
                            </div>
                            <div class="text-center">
                                <button type="submit" class="btn btn-primary">Save</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>   
        <!-- Modal Add Answer  -->
        <div class="modal fade" id="answerDetail" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="answerDetailLabel">Tambahkan Tipe Jawaban</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form class="row g-3" @submit.prevent="addAnswer">
                            <div class="col-md-6">
                                <div class="form-floating">
                                        <input type="text" class="form-control" id="updated_by" placeholder="ID" v-model="selectedAnswer.created_by" readonly/>
                                        <label for="updated_by">ID User</label>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-floating">
                                <input type="text" class="form-control" id="updated_by_name" placeholder="Nama PEmbuat" v-model="selectedAnswer.created_by_name" readonly/>
                                <label for="updated_by_name">Nama User</label>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-floating">
                                    <input type="text" class="form-control" id="questionId" placeholder="ID" v-model="question.id" readonly>
                                    <label for="questionId">ID</label>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-floating">
                                    <input type="text" class="form-control" id="questionText" placeholder="Question" v-model="question.question" readonly>
                                    <label for="questionText">Pertanyaan</label>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-floating">
                                    <select 
                                        name="id" 
                                        id="id" 
                                        class="form-select"
                                        v-model="selectedAnswer.answer_id">
                                        <option v-for="(answer) in answerList" :key="answer.answer_id" :value="answer.answer_id">
                                            {{ answer.answer }} - {{ answer.answer_type }}
                                        </option>
                                    </select>
                                    <label for="id">Answer</label>
                                </div>
                            </div>
                            <div class="col-md-12 mb-3">
                                <div class="form-floating">
                                <select class="form-select" name="is_active" id="is_active" v-model="selectedAnswer.status">
                                    <option value="1">Active</option>
                                    <option value="0">Inactive</option>
                                </select>
                                <label for="is_active">Status</label>
                                </div>
                            </div>
                            <div class="text-center">
                                <button type="submit" class="btn btn-primary">Save</button>
                            </div>
                        </form>
                        <br>
                        <table class="table table-striped table-hover" >
                            <thead class="thead-dark">
                                <tr>
                                    <th>No.</th>
                                    <th>Jawaban</th>
                                    <th scope="col" style="text-align: center;">Opsi</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(detail, index) in q_detail" :key="detail.id">
                                    <th scope="row">{{ index + 1 }}</th>
                                    <td>{{ detail.answer }}</td>
                                    <td style="text-align: center;">
                                        <a href="#" class="btn btn-sm btn-outline-danger shadow-sm" style="margin-right: 5px" @click="deleteDetail(detail.id, detail.question_id)">
                                            <i class="bi bi-trash fa-sm text-dark"></i>
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import questionjs from './jsQuestion/question';
export default questionjs;
</script>